// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-container {
  position: relative;
  width: 100%;
  color: var(--m-text);
}
.user-container .header__user img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  background: #f8f8fb;
  padding: 0.25rem;
}
.user-container--icon {
  font-size: 20px;
  color: var(--m-text);
}
.user-container__content-dropdown {
  min-width: 240px;
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  z-index: 1000;
}
.user-container__content-dropdown::before {
  content: "";
  position: absolute;
  top: -6px;
  right: 20px;
  width: 12px;
  height: 12px;
  background: var(--bs-body-bg);
  border-left: 1px solid var(--bs-border-color);
  border-top: 1px solid var(--bs-border-color);
  transform: rotate(45deg);
}
.user-container__content-dropdown svg {
  color: var(--m-icon-color);
  font-size: 18px;
}
.user-container__content-dropdown__label {
  font-size: 13px;
  font-weight: 500;
}
.user-container__content-dropdown__logout {
  width: 100%;
  padding: 16px;
  border-top: 1px solid var(--m-border-color);
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-container__content-dropdown__logout__button {
  background-color: transparent;
  border: 1px solid var(--m-border-color);
  width: 100%;
  padding: 10px 0;
  border-radius: var(--m-border-radius);
  cursor: pointer;
  color: var(--m-text);
}
.user-container__content-dropdown__logout__button:hover {
  box-shadow: 0 3px 8px rgba(9, 30, 66, 0.15);
}
.user-container__content-dropdown.dropdown-container__content {
  position: fixed;
  top: auto;
  transform: translateY(0);
}
.user-container__infos {
  padding: 16px;
  border-bottom: 1px solid var(--bs-border-color);
  display: flex;
  align-items: center;
  gap: 12px;
}
.user-container__infos__info {
  display: flex;
  flex-direction: column;
}
.user-container__infos__info .user-name {
  font-weight: 500;
  color: var(--bs-body-color);
}
.user-container__infos__info .user-email {
  font-size: 0.875rem;
  color: var(--bs-secondary-color);
}
.user-container__quick-controls {
  padding: 10px 14px;
  border-bottom: 1px solid var(--bs-border-color);
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: var(--m-subtle-card-background-color, rgba(0, 0, 0, 0.02));
}
.user-container__control-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 10px;
  border-radius: 6px;
  cursor: pointer;
  background: var(--m-content-background, #fff);
  border: 1px solid var(--m-border-color, rgba(0, 0, 0, 0.08));
  transition: all 0.15s ease;
}
.user-container__control-row:hover {
  border-color: var(--m-primary, #3b82f6);
  background-color: var(--m-hover-color, rgba(59, 130, 246, 0.05));
}
.user-container__control-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--bs-body-color);
}
.user-container__control-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: var(--m-primary, #3b82f6);
}
.user-container__pill-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: var(--m-content-background);
  border: 1px solid var(--m-border-color);
  color: var(--m-text-light);
}
.user-container__exchange-card {
  padding: 8px 10px;
  border-radius: 6px;
  background: var(--m-content-background, #fff);
  border: 1px solid var(--m-border-color, rgba(0, 0, 0, 0.08));
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.user-container__exchange-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 10px;
  text-transform: uppercase;
  color: var(--m-text-light, #888);
  letter-spacing: 0.5px;
}
.user-container__exchange-header .exchange-title {
  font-weight: 600;
}
.user-container__exchange-header .exchange-date {
  font-size: 10px;
}
.user-container__exchange-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.user-container__exchange-body .exchange-rate {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--bs-body-color);
  white-space: nowrap;
}
.user-container__exchange-body .exchange-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 14px;
  background: var(--m-content-background);
  border: 1px solid var(--m-border-color);
  font-size: 11px;
  font-weight: 600;
  color: var(--m-text-color);
  cursor: pointer;
  transition: all 0.15s ease;
}
.user-container__exchange-body .exchange-toggle-btn .exchange-toggle-icon {
  color: var(--m-primary, #3b82f6);
}
.user-container__exchange-body .exchange-toggle-btn:hover:not(:disabled) {
  background-color: var(--m-primary, #3b82f6);
  color: #fff;
  border-color: var(--m-primary, #3b82f6);
}
.user-container__exchange-body .exchange-toggle-btn:hover:not(:disabled) .exchange-toggle-icon {
  color: #fff;
}
.user-container__exchange-body .exchange-toggle-btn:disabled {
  opacity: 0.6;
  cursor: wait;
}
.user-container__menu {
  padding: 8px 0;
}
.user-container__menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  color: var(--bs-body-color);
}
.user-container__menu .dropdown-item:hover {
  background-color: var(--bs-primary-bg-subtle);
}
.user-container__menu .dropdown-item svg {
  font-size: 1.25rem;
  color: var(--bs-secondary-color);
}

.dropdown {
  position: relative;
}
.dropdown__content {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 8px;
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/UserDropdown/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,oBAAA;AACF;AAEI;EACE,WAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAAN;AAIE;EACE,eAAA;EACA,oBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,6BAAA;EACA,wCAAA;EACA,kBAAA;EACA,yCAAA;EACA,eAAA;EACA,aAAA;AAHJ;AAKI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,6CAAA;EACA,4CAAA;EACA,wBAAA;AAHN;AAMI;EACE,0BAAA;EACA,eAAA;AAJN;AAOI;EACE,eAAA;EACA,gBAAA;AALN;AAQI;EACE,WAAA;EACA,aAAA;EACA,2CAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AANN;AAQM;EACE,6BAAA;EACA,uCAAA;EACA,WAAA;EACA,eAAA;EACA,qCAAA;EACA,eAAA;EACA,oBAAA;AANR;AAQQ;EACE,2CAAA;AANV;AAWI;EACE,eAAA;EACA,SAAA;EACA,wBAAA;AATN;AAaE;EACE,aAAA;EACA,+CAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAXJ;AAaI;EACE,aAAA;EACA,sBAAA;AAXN;AAaM;EACE,gBAAA;EACA,2BAAA;AAXR;AAcM;EACE,mBAAA;EACA,gCAAA;AAZR;AAiBE;EACE,kBAAA;EACA,+CAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,4EAAA;AAfJ;AAkBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;EACA,4DAAA;EACA,0BAAA;AAhBJ;AAkBI;EACE,uCAAA;EACA,gEAAA;AAhBN;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,uCAAA;EACA,0BAAA;AApBJ;AAuBE;EACE,iBAAA;EACA,kBAAA;EACA,6CAAA;EACA,4DAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AArBJ;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,yBAAA;EACA,gCAAA;EACA,qBAAA;AAtBJ;AAwBI;EACE,gBAAA;AAtBN;AAyBI;EACE,eAAA;AAvBN;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAzBJ;AA2BI;EACE,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;AAzBN;AA4BI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,0BAAA;AA1BN;AA4BM;EACE,gCAAA;AA1BR;AA6BM;EACE,2CAAA;EACA,WAAA;EACA,uCAAA;AA3BR;AA6BQ;EACE,WAAA;AA3BV;AA+BM;EACE,YAAA;EACA,YAAA;AA7BR;AAkCE;EACE,cAAA;AAhCJ;AAkCI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,2BAAA;AAhCN;AAkCM;EACE,6CAAA;AAhCR;AAmCM;EACE,kBAAA;EACA,gCAAA;AAjCR;;AAuCA;EACE,kBAAA;AApCF;AAsCE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;AApCJ","sourcesContent":[".user-container {\n  position: relative;\n  width: 100%;\n  color: var(--m-text);\n\n  .header__user {\n    img {\n      width: 100%;\n      height: 100%;\n      -o-object-fit: cover;\n      object-fit: cover;\n      border-radius: 50%;\n      background: #f8f8fb;\n      padding: 0.25rem;\n    }\n  }\n\n  &--icon {\n    font-size: 20px;\n    color: var(--m-text);\n  }\n\n  &__content-dropdown {\n    min-width: 240px;\n    background: var(--bs-body-bg);\n    border: 1px solid var(--bs-border-color);\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    margin-top: 8px;\n    z-index: 1000;\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: -6px;\n      right: 20px;\n      width: 12px;\n      height: 12px;\n      background: var(--bs-body-bg);\n      border-left: 1px solid var(--bs-border-color);\n      border-top: 1px solid var(--bs-border-color);\n      transform: rotate(45deg);\n    }\n\n    svg {\n      color: var(--m-icon-color);\n      font-size: 18px;\n    }\n\n    &__label {\n      font-size: 13px;\n      font-weight: 500;\n    }\n\n    &__logout {\n      width: 100%;\n      padding: 16px;\n      border-top: 1px solid var(--m-border-color);\n      margin-top: 16px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      &__button {\n        background-color: transparent;\n        border: 1px solid var(--m-border-color);\n        width: 100%;\n        padding: 10px 0;\n        border-radius: var(--m-border-radius);\n        cursor: pointer;\n        color: var(--m-text);\n\n        &:hover {\n          box-shadow: 0 3px 8px rgba(9, 30, 66, 0.15);\n        }\n      }\n    }\n\n    &.dropdown-container__content {\n      position: fixed; // Change to fixed\n      top: auto; // Reset top\n      transform: translateY(0); // Reset transform\n    }\n  }\n\n  &__infos {\n    padding: 16px;\n    border-bottom: 1px solid var(--bs-border-color);\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    &__info {\n      display: flex;\n      flex-direction: column;\n\n      .user-name {\n        font-weight: 500;\n        color: var(--bs-body-color);\n      }\n\n      .user-email {\n        font-size: 0.875rem;\n        color: var(--bs-secondary-color);\n      }\n    }\n  }\n\n  &__quick-controls {\n    padding: 10px 14px;\n    border-bottom: 1px solid var(--bs-border-color);\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    background-color: var(--m-subtle-card-background-color, rgba(0, 0, 0, 0.02));\n  }\n\n  &__control-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 7px 10px;\n    border-radius: 6px;\n    cursor: pointer;\n    background: var(--m-content-background, #fff);\n    border: 1px solid var(--m-border-color, rgba(0, 0, 0, 0.08));\n    transition: all 0.15s ease;\n\n    &:hover {\n      border-color: var(--m-primary, #3b82f6);\n      background-color: var(--m-hover-color, rgba(59, 130, 246, 0.05));\n    }\n  }\n\n  &__control-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--bs-body-color);\n  }\n\n  &__control-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    color: var(--m-primary, #3b82f6);\n  }\n\n  &__pill-tag {\n    font-size: 11px;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: 12px;\n    background-color: var(--m-content-background);\n    border: 1px solid var(--m-border-color);\n    color: var(--m-text-light);\n  }\n\n  &__exchange-card {\n    padding: 8px 10px;\n    border-radius: 6px;\n    background: var(--m-content-background, #fff);\n    border: 1px solid var(--m-border-color, rgba(0, 0, 0, 0.08));\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__exchange-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 10px;\n    text-transform: uppercase;\n    color: var(--m-text-light, #888);\n    letter-spacing: 0.5px;\n\n    .exchange-title {\n      font-weight: 600;\n    }\n\n    .exchange-date {\n      font-size: 10px;\n    }\n  }\n\n  &__exchange-body {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n\n    .exchange-rate {\n      font-size: 12.5px;\n      font-weight: 600;\n      color: var(--bs-body-color);\n      white-space: nowrap;\n    }\n\n    .exchange-toggle-btn {\n      display: inline-flex;\n      align-items: center;\n      gap: 4px;\n      padding: 3px 8px;\n      border-radius: 14px;\n      background: var(--m-content-background);\n      border: 1px solid var(--m-border-color);\n      font-size: 11px;\n      font-weight: 600;\n      color: var(--m-text-color);\n      cursor: pointer;\n      transition: all 0.15s ease;\n\n      .exchange-toggle-icon {\n        color: var(--m-primary, #3b82f6);\n      }\n\n      &:hover:not(:disabled) {\n        background-color: var(--m-primary, #3b82f6);\n        color: #fff;\n        border-color: var(--m-primary, #3b82f6);\n\n        .exchange-toggle-icon {\n          color: #fff;\n        }\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: wait;\n      }\n    }\n  }\n\n  &__menu {\n    padding: 8px 0;\n\n    .dropdown-item {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 8px 16px;\n      color: var(--bs-body-color);\n\n      &:hover {\n        background-color: var(--bs-primary-bg-subtle);\n      }\n\n      svg {\n        font-size: 1.25rem;\n        color: var(--bs-secondary-color);\n      }\n    }\n  }\n}\n\n.dropdown {\n  position: relative;\n\n  &__content {\n    position: absolute;\n    right: 0;\n    top: 100%;\n    margin-top: 8px;\n    z-index: 1000;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
